import { useTranslation, useProperty } from '@eti/providers';
import { analytics } from '@eti/utils';
import { css, mediaQueries } from '@eti/styles';
import { useRef } from 'react';
import { useLinksAccessibility } from '../../../custom-hooks/useLinkAccessibility';
import ProductLayout from '../../main-layout/ProductLayout';
import { usePictogram } from '../../utils/useIllustration';
import { getPrice, getProduct } from '../../../single-choice/utils/singleChoiceTransformer';
import { getModal, getPriceProps, getReadMoreLabel, getSingleChoiceProps } from '../../utils/productCardProps';
import SmallCardReadMore from './SmallCardReadMore';
import { jsx as _jsx } from "react/jsx-runtime";
export const smallCardGrid = css`
  display: grid;
  grid-gap: 16px 8px;
  grid-template-columns: 32px 1fr;
  grid-template-rows: repeat(4, auto);
  padding: 16px;

  .illustration {
    grid-area: 1 / 1 / 5 / 2;
  }

  .header {
    grid-area: 1 / 2 / 2 / 3;
    padding: 0;
  }

  .body {
    grid-area: 2 / 2 / 3 / 3;
    padding: 0;
  }

  .readMore {
    grid-area: 3 / 2 / 4 / 3;
    padding: 0;
  }

  .cta {
    grid-area: 4 / 2 / 5 / 3;
    padding: 0;

    .selection {
      grid-area: 1 / 2 / 2 / 3;
      margin-bottom: 8px;

      @media ${mediaQueries.small.only} {
        grid-area: 2 / 1 / 3 / 2;
        margin-bottom: 0;
      }
    }
  }

  .children {
    display: contents;
  }

  @media ${mediaQueries.small.only} {
    grid-column-gap: 0;
    grid-template-columns: 0 1fr;

    .body {
      margin-inline-start: 40px;
    }
  }
`;
const SmallCardLayout = _ref => {
  var _order$persuasion$isE, _order$persuasion;
  let {
    confirmation,
    description,
    form,
    isSelected,
    order,
    persuasion,
    productId,
    productName,
    productType,
    readMoreContent,
    title,
    sellSpecification
  } = _ref;
  analytics.useLogMouseFlowTagEffect('Small card');
  const {
    t,
    nonDebugT
  } = useTranslation();
  const {
    p
  } = useProperty();
  const rootElement = useRef(null);
  useLinksAccessibility({
    targetElement: rootElement,
    productTitle: title
  });
  const readMoreLink = t('Products.ReadMore.Link.Label');
  const extraProps = {
    ...getSingleChoiceProps(t, p, nonDebugT),
    readMoreLink
  };
  const pictogramUrl = usePictogram(productName);
  const product = getProduct(productId, order, productType);
  if (!product) {
    return null;
  }
  const priceRaw = getPrice(order, productType);
  const {
    priceLabel,
    price,
    priceSuffix
  } = getPriceProps(t, isSelected, product);
  const productCardModal = getModal((_order$persuasion$isE = (_order$persuasion = order.persuasion) === null || _order$persuasion === void 0 ? void 0 : _order$persuasion.isEnabled) !== null && _order$persuasion$isE !== void 0 ? _order$persuasion$isE : false, confirmation !== null && confirmation !== void 0 ? confirmation : '', persuasion !== null && persuasion !== void 0 ? persuasion : '');
  const readMoreButtonLabel = getReadMoreLabel(t);
  const productData = {
    sellSpecification,
    extraProps,
    description,
    form,
    illustrationUrl: pictogramUrl,
    isSelected,
    price,
    priceLabel,
    priceRaw,
    priceSuffix,
    productId,
    productName,
    readMoreButtonLabel,
    readMoreContent,
    title,
    productCardModal,
    shouldDisplayUpsell: false
  };
  return /*#__PURE__*/_jsx(ProductLayout, {
    className: "singleChoice",
    customGrid: smallCardGrid,
    productData: productData,
    ref: rootElement,
    children: /*#__PURE__*/_jsx(ProductLayout.ReadMore, {
      override: true,
      children: /*#__PURE__*/_jsx(SmallCardReadMore, {})
    })
  });
};
export default SmallCardLayout;
//# sourceMappingURL=SmallCardLayout.js.map